import { viewerBackground } from '@/theme/colors';
import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const ParentContainer = muiStyled(Box)<{ navbarHeight: number }>(({ navbarHeight }) => ({
  paddingTop: navbarHeight,
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  height: 'calc(100vh / var(--zoom))',
  background: viewerBackground,
  overflow: 'hidden',
}));
